<img
  [src]="src | src: isOrch"
  [alt]="alt ? alt : src ? src : ''"
  [style.width]="size || 'auto'"
  [style.height]="size || 'auto'"
  class="inline-block rounded-[inherit]"
/>
